export default __webpack_public_path__ + "static/decorist-7-b52c00945bb10e70adf4d7c9544d1f8a.webp";